import React, { useState, useEffect, useContext } from "react";
import SiteVisit from "../components/SiteVisit";
import { nanoid } from "nanoid";
import { TourContext } from "../services/TourContext";
import logger from "../services/Logger";

export default function ItineraryCheckboxList({ items, startTime, timeOnProperty }) {
  const [consolidatedList, setConsolidatedList] = useState([]);

  const { setTourInfo } = useContext(TourContext);

  useEffect(() => {
    logger.info("Setting tour info with the consolidated list in its own use effect - ", consolidatedList);
    setTourInfo({ consolidatedList, startTime, timeOnProperty });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consolidatedList]);

  useEffect(() => {
    const date = new Date(startTime);
    let departureTime;
    let arrivalTime;
    const allSites = [];
    if (items && items[0]) {
      items[0].legs.forEach((leg) => {
        const commuteToNextSite = Math.ceil(leg.duration.value / 60);
        date.setMinutes(date.getMinutes() + commuteToNextSite);
        arrivalTime = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        date.setMinutes(date.getMinutes() + timeOnProperty);
        const hours = String(date.getHours()).padStart(2, "0");
        const mins = String(date.getMinutes()).padStart(2, "0");
        departureTime = `${hours}:${mins}`;

        logger.info("This is the leg - ", leg);
        const startAddress = leg.start_address;
        const endAddress = leg.end_address;

        allSites.push({
          arrivalTime: arrivalTime,
          departureTime: departureTime,
          endLocationAddress: endAddress,
          startLocationAddress: startAddress,
          timeOnProperty: timeOnProperty,
          commuteTimeToNextSite: commuteToNextSite,
        });
      });
      logger.rnd("Setting tour info with the consolidated list - ", allSites);

      setConsolidatedList(allSites);
    }
  }, [items, startTime, timeOnProperty]);

  const handleDataUpdate = (data) => {
    console.log("This is the data updated ", data);

    setConsolidatedList(replaceItemInArray(consolidatedList, data));
  };

  const replaceItemInArray = (array, newData) => {
    return array.map((item) => {
      if (item.locationAddress === newData.locationAddress) {
        return {
          arrivalTime: item.currentTime,
          locationAddress: item.locationAddress,
          timeOnProperty: newData.timeOnProperty,
          commuteTimeToNextSite: item.commuteToNextSite,
        };
      }
      return item;
    });
  };

  return (
    <div>
      <div>{consolidatedList && consolidatedList.map((site) => <SiteVisit key={nanoid()} {...site} onDataUpdate={handleDataUpdate}></SiteVisit>)}</div>
    </div>
  );
}
